import { CircularProgress, Grid } from "@mui/material";
import classes from "./Login.module.css";
import CarouselComponent from "../UI/Carousel/Carousel";
import SimpleInput from "../UI/SimpleInput/SimpleInput";
import { ReactComponent as LeftArrow } from "../../images/icons/forms/arrowLeft.svg";
import { ReactComponent as OTPIcon } from "../../images/icons/forms/passwordCheck.svg";
import useDelayUnmount from "../../hooks/useDelayUnmount";
import { useEffect, useRef, useState } from "react";
import useCountDown from "../../hooks/useCountDown";
import Timer from "../Timer/Timer";
import { toast } from "react-toastify";
import validate from "../../utils/validations/validateV2";

const Login = ({
  images,
  fieldsSchema,
  loginHandler,
  otpIsSending,
  formIsSending,
  otpHandler,
  helperTxt,
  setTopUsername,
}) => {
  const [data, setData] = useState(() => {
    if (Array.isArray(fieldsSchema)) {
      return fieldsSchema.reduce((acc, fileInfo) => {
        acc[fileInfo.fieldName] = "";
        return acc;
      }, {});
    } else return null;
  });
  const [formValidity, setFormValidity] = useState(() => {
    if (Array.isArray(fieldsSchema)) {
      return fieldsSchema.reduce((acc, fileInfo) => {
        acc[fileInfo.fieldName] = { isValid: true, msg: "" };
        return acc;
      }, {});
    } else return null;
  });
  const [otpIsMounted, setOtpIsMounted] = useState(false);
  const [formIsMounted, setFormIsMounted] = useState(true);
  const showOtp = useDelayUnmount(otpIsMounted, 350);
  const showForm = useDelayUnmount(formIsMounted, 350);
  const [otp, setOtp] = useState({ value: "" });
  const { countDown, setCountDown, clearTimer, getDeadTime } = useCountDown();
  const otpRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (otpRef.current) {
        otpRef.current.focus();
      }
    }, 1001);
  }, [showOtp, otpIsMounted, otpRef.current]);

  const blurHandler = (e, validationType) => {
    const validationValue = validate({ data: e.target.value, type: validationType || "mandatory" });
    setFormValidity((ps) => ({ ...ps, [e.target.name]: validationValue }));
  };
  const changeHandler = (e) => {
    setData((ps) => ({ ...ps, [e.target.name]: e.target.value }));
    if (setTopUsername) {
      if (e.target.name === "username") {
        setTopUsername(e.target.value);
      }
    }
  };

  const loginClick = async (e) => {
    const wasSuccessfull = await loginHandler({
      setOtpIsMounted,
      setFormIsMounted,
      data,
      setData,
      setFormValidity,
    });
    if (wasSuccessfull === true) {
      try {
        const credentials = await navigator.credentials.get({
          otp: { transport: ["sms"] },
        });
        const otp = credentials.code;
        setOtp({ value: otp });
      } catch (error) {
        console.error("Error getting OTP credentials:", error);
      }
    }
  };
  const otpClickHandler = async (e) => {
    if (countDown !== "00:00") {
      if (otp.value.trim().length === 6) {
        await otpHandler({ otp: otp.value, data });
      } else {
        toast.error("پیام ارسال شده را کامل وارد کنید");
      }
    } else {
      const restartTimer = () => clearTimer(getDeadTime());
      await loginHandler({ data, setData, setFormValidity, restartTimer });
      setOtp((ps) => ({ ...ps, value: "" }));
      otpRef.current.focus();
    }
  };
  const checkEnterClicked = async (e, type) => {
    if (e.key === "Enter") {
      if (type === "login") await loginClick();
      if (type === "verify") await otpClickHandler();
    }
  };
  const returnToLoginHandler = (e) => {
    setOtpIsMounted(false);
    setFormIsMounted(true);
    setOtp((ps) => ({ ...ps, value: "" }));
  };

  return (
    <Grid container className={classes.rootContainer}>
      <Grid container item xs={12} className={classes.container}>
        <Grid container item xs={12} sm={6.5} md={6} className={classes.formPart}>
          <Grid container item xs={11} sm={10} md={9} lg={8} className={classes.borderedContainer}>
            {showForm && (
              <Grid
                container
                item
                xs={12}
                className={[
                  classes.loginInfosContainer,
                  formIsMounted ? classes.otpMounted : classes.otpUnmounted,
                ].join(" ")}
              >
                {/* <Grid container item xs={11.5} sm={11} md={9} lg={7} className={classes.formWrapper}> */}
                <h2 className={classes.welcomeTitle}>خوش آمدید!</h2>
                <p className={classes.welcomeText}>
                  {helperTxt
                    ? helperTxt
                    : " برای ورود به سیستم لطفا نام کاربری و رمز عبور خود را وارد کنید."}{" "}
                </p>
                <div className={classes.formWrapper}>
                  {fieldsSchema.map((fieldSchema, index) => (
                    <div className={classes.inputContainer} key={fieldSchema.id}>
                      <SimpleInput
                        value={data[fieldSchema.fieldName]}
                        iName={fieldSchema.fieldName}
                        label={fieldSchema.label}
                        onBlur={(e) => blurHandler(e, fieldSchema?.validationType)}
                        onChange={changeHandler}
                        type={fieldSchema.type}
                        validityName={formValidity?.[fieldSchema.fieldName]}
                        labelIcon={fieldSchema.labelIcon}
                        onKeyDown={(e) =>
                          index === fieldsSchema.length - 1 ? checkEnterClicked(e, "login") : null
                        }
                        maxLength={fieldSchema.maxLength}
                      />
                    </div>
                  ))}
                </div>
                {/* </Grid> */}
                {/* <Grid container item xs={11.5} sm={11} md={9} lg={7} className={classes.submitGrid}> */}
                <div className={classes.loginReqBtnContainer}>
                  <button className={classes.submitBtn} onClick={loginClick}>
                    {formIsSending ? (
                      <CircularProgress className={classes.progress} />
                    ) : (
                      <>
                        <span className={classes.submitTxt}>ورود به سیستم</span>
                        <LeftArrow />
                      </>
                    )}
                  </button>
                </div>
                {/* </Grid> */}
              </Grid>
            )}
            {showOtp && (
              <Grid
                container
                item
                xs={12}
                className={[
                  classes.otpAbsolutePosition,
                  otpIsMounted ? classes.otpMounted : classes.otpUnmounted,
                ].join(" ")}
              >
                <Grid container item xs={11.5} sm={11} md={10} lg={9} className={classes.otpContainer}>
                  <div className={classes.inputContainer}>
                    <SimpleInput
                      value={otp.value}
                      iName="value"
                      onChange={(e) => setOtp((ps) => ({ ...ps, [e.target.name]: e.target.value }))}
                      type="number"
                      labelIcon={<OTPIcon />}
                      helperTxt="کد 6 رقمی ارسال شده را وارد کنید."
                      valueStyleType="largeCentered"
                      maxLength={6}
                      ref={otpRef}
                      onKeyDown={(e) => checkEnterClicked(e, "verify")}
                    />
                  </div>
                  <div className={classes.actionBtnsContainer}>
                    <div className={classes.returnContainer}>
                      <button className={classes.returnBtn} onClick={returnToLoginHandler}>
                        <LeftArrow />
                        بازگشت
                      </button>
                    </div>
                    <div className={classes.submitBtnsContainer}>
                      <span className={classes.countDownContainer}>
                        <Timer
                          countDown={countDown}
                          setCountDown={setCountDown}
                          clearTimer={clearTimer}
                          getDeadTime={getDeadTime}
                        />
                      </span>
                      <button className={classes.submitBtn} onClick={otpClickHandler}>
                        {otpIsSending || formIsSending ? (
                          <CircularProgress className={classes.progress} />
                        ) : countDown === "00:00" ? (
                          <span className={classes.sendAgainTxt}>ارسال مجدد کد</span>
                        ) : (
                          <>
                            <span className={classes.submitTxt}>ورود</span>
                            <LeftArrow />
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid container item xs={12} sm={5.5} md={6} className={classes.carouselPart}>
          <Grid
            container
            item
            xs={12}
            // sm={11} md={10}
            className={classes.carouselPart}
          >
            <div className={classes.carouselContainer}>
              <CarouselComponent items={images} styleType="radiusBorder" />
            </div>
          </Grid>
        </Grid>
        {/* <button
          className={classes.submitBtn}
          onClick={() => {
            setOtpIsMounted((ps) => !ps);
            setFormIsMounted((ps) => !ps);
          }}
        >
          <span className={classes.submitTxt}>animation</span>
          <LeftArrow />
        </button> */}
      </Grid>
    </Grid>
  );
};

export default Login;
